export const handlePostResultsUI = () => {
    if (!document.body.classList.contains("page-post-results")) return;

    addStringToTotalResults();
};

export const addStringToTotalResults = () => {
    const pagination = document.querySelector('.layout-post__pagination-container--top .attrax-pagination__total-results');
    if (pagination) {
        pagination.textContent = '{{js.page.post-results.pagination.total-results}}' + pagination.textContent;
    }
};